import Wholesale from '../Components/App/Ecommerce/WholesaleOrderForm';

export const authRoutes = [
  { path: `/collection-order-form`, Component: <Wholesale/> },
];
